import React, { useEffect, useState } from 'react';
import { isConsentValid, saveConsent } from '../services/gdprService';

export default function GDPRModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (isConsentValid()) return; // consent still valid — don't show
    } catch (e) {
      // if service fails for any reason, show modal
    }
    setVisible(true);
  }, []);

  const saveChoice = (accepted) => {
    try {
      saveConsent(accepted);
    } catch (e) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" aria-hidden="true" />

      <div
        role="dialog"
        aria-modal="true"
        aria-label="GDPR consent"
        className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 max-h-[90vh] flex flex-col"
      >
        <div className="p-6 md:p-8 bg-gradient-to-r from-green-800 via-green-700 to-emerald-700 text-white flex-shrink-0">
          <h2 className="text-xl md:text-2xl font-semibold">Privacy & Cookies (GDPR)</h2>
          <p className="mt-2 text-sm md:text-base text-green-100">
            We use cookies and similar technologies to improve your experience and analyze
            traffic. You can accept all cookies or decline. Your choice will be saved for 30 days.
          </p>
        </div>

        {/* Scrollable content section */}
        <div className="overflow-y-auto flex-1 p-6 md:p-8 bg-white" style={{ maxHeight: '400px' }}>
          <div className="text-sm text-gray-700 space-y-4">
            <h3 className="font-semibold text-base text-gray-900">Privacy Policy</h3>
            
            <p>
              This website uses cookies and similar technologies to provide you with a better experience, 
              analyze site traffic, and assist in our marketing efforts.
            </p>

            <h4 className="font-semibold text-gray-900 mt-4">What are cookies?</h4>
            <p>
              Cookies are small text files that are placed on your device when you visit our website. 
              They help us recognize you and remember your preferences for future visits.
            </p>

            <h4 className="font-semibold text-gray-900 mt-4">How we use cookies</h4>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Essential cookies:</strong> Required for the website to function properly</li>
              <li><strong>Analytics cookies:</strong> Help us understand how visitors interact with our website</li>
              <li><strong>Marketing cookies:</strong> Used to track visitors across websites to display relevant advertisements</li>
            </ul>

            <h4 className="font-semibold text-gray-900 mt-4">Your choices</h4>
            <p>
              You can choose to accept or decline cookies. If you decline, some features of the website 
              may not function as intended. Your preference will be saved for 30 days.
            </p>

            <h4 className="font-semibold text-gray-900 mt-4">Data protection</h4>
            <p>
              We are committed to protecting your privacy and personal data in accordance with GDPR regulations. 
              Your data will never be sold to third parties.
            </p>

            <p className="mt-4 text-xs text-gray-500">
              Last updated: January 2026
            </p>
          </div>
        </div>

        {/* Action buttons */}
        <div className="p-6 md:p-8 bg-gray-50 border-t border-gray-100 flex-shrink-0">
          <div className="flex items-center justify-end gap-3">
            <button
              onClick={() => saveChoice(false)}
              className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 font-medium transition-colors"
            >
              Decline
            </button>

            <button
              onClick={() => saveChoice(true)}
              className="px-5 py-2.5 rounded-lg bg-green-700 text-white font-medium shadow hover:bg-green-800 transition-colors"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
